var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list && _vm.list.length)?_c('div',[_c('Container',{staticClass:"list-unstyled chat-list",attrs:{"tag":"ul","drag-handle-selector":".draggable-item-trigger-a","lock-axis":"y","drag-begin-delay":0,"get-child-payload":(itemIndex) => _vm.getChildPayload(itemIndex, _vm.list)},on:{"drop":function($event){return _vm.onDrop($event, _vm.list)}}},[(_vm.item && _vm.item.draggable)?_vm._l((_vm.list),function(data){return _c('Draggable',{key:data.id,class:{ active: data.id == _vm.selectedItem.id },attrs:{"tag":"li"}},[_c('div',{staticClass:"draggable-item-trigger-item",style:((data.active && _vm.topbarControls.config.activeToggle) ||
            (data.practices &&
              data.practices.length &&
              data.practices.find(
                (x) => x.practice_id == _vm.currentPractice.id
              ) &&
              data.practices.find((x) => x.practice_id == _vm.currentPractice.id)
                .active)
              ? 'border-left: 5px solid #22b14c'
              : ''),on:{"click":function($event){return _vm.switchItem(data)}}},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"draggable-item-trigger-a draggable-item-trigger-container pl-3 handle",class:{
                'd-none': _vm.variant && _vm.variant == 'simple',
                'd-none': _vm.item && _vm.item.draggable === false,
              }},[_c('div',{staticClass:"draggable-item-trigger"})]),_c('div',{staticClass:"media-body overflow-hidden p-2"},[(
                  _vm.item.featuredIcon_position &&
                  _vm.item.featuredIcon_position === 'right'
                )?_c('div',{staticClass:"text-truncate font-size-14 mb-0 px-0 flex"},[(
                    data.id == _vm.selectedItem.id
                      ? _vm.selectedItem.featured
                      : data.featured
                  )?[_c('div',{staticClass:"align-top col-11 p-0 ellipsis",style:(data &&
                      data.additionalProp1 &&
                      data.additionalProp1.global
                        ? data.practices &&
                          data.practices.find(
                            (x) => x.practice_id == _vm.currentPractice.id
                          ) &&
                          !data.practices.find(
                            (x) => x.practice_id == _vm.currentPractice.id
                          ).active
                          ? data.id !== _vm.selectedItem.id
                            ? 'color: gray'
                            : ''
                          : ''
                        : 'active' in data && !data.active
                        ? data.id !== _vm.selectedItem.id
                          ? 'color: gray'
                          : ''
                        : '')},[_vm._v(" "+_vm._s(_vm.moment(data.title, "YYYY-MM-DD", true).isValid() ? _vm.moment(new Date(data.title)).format("DD MMMM, YYYY") : data.title)+" ")]),_c('div',[(
                        data.id == _vm.selectedItem.id
                          ? _vm.selectedItem.featured
                          : data.featured
                      )?_c('i',{staticClass:"ri-star-fill mr-2",staticStyle:{"color":"gold"}}):_vm._e()])]:[_c('div',{staticClass:"align-top p-0 ellipsis",style:(data &&
                      data.additionalProp1 &&
                      data.additionalProp1.global
                        ? data.practices &&
                          data.practices.find(
                            (x) => x.practice_id == _vm.currentPractice.id
                          ) &&
                          !data.practices.find(
                            (x) => x.practice_id == _vm.currentPractice.id
                          ).active
                          ? data.id !== _vm.selectedItem.id
                            ? 'color: gray'
                            : ''
                          : ''
                        : 'active' in data && !data.active
                        ? data.id !== _vm.selectedItem.id
                          ? 'color: gray'
                          : ''
                        : '')},[_vm._v(" "+_vm._s(_vm.moment(data.title, "YYYY-MM-DD", true).isValid() ? _vm.moment(new Date(data.title)).format("DD MMMM, YYYY") : data.title)+" ")])]],2):_c('p',{staticClass:"text-truncate font-size-14 mb-0 px-2"},[(
                    data.id == _vm.selectedItem.id
                      ? _vm.selectedItem.featured
                      : data.featured
                  )?_c('i',{staticClass:"ri-star-fill mr-2",staticStyle:{"color":"gold"}}):_vm._e(),_c('span',{staticClass:"align-top",style:(data &&
                    data.additionalProp1 &&
                    data.additionalProp1.global
                      ? data.practices &&
                        data.practices.find(
                          (x) => x.practice_id == _vm.currentPractice.id
                        ) &&
                        !data.practices.find(
                          (x) => x.practice_id == _vm.currentPractice.id
                        ).active
                        ? data.id !== _vm.selectedItem.id
                          ? 'color: gray'
                          : ''
                        : ''
                      : 'active' in data && !data.active
                      ? data.id !== _vm.selectedItem.id
                        ? 'color: gray'
                        : ''
                      : '')},[_vm._v(" "+_vm._s(_vm.moment(data.title, "YYYY-MM-DD", true).isValid() ? _vm.moment(new Date(data.title)).format("DD MMMM, YYYY") : data.title)+" ")])])])])])])}):_vm._l((_vm.list),function(data){return _c('li',{key:data.id,class:{ active: data.id == _vm.selectedItem.id }},[_c('div',{staticClass:"draggable-item-trigger-item",style:((data.active && _vm.topbarControls.config.activeToggle) ||
            (data.practices &&
              data.practices.length &&
              data.practices.find(
                (x) => x.practice_id == _vm.currentPractice.id
              ) &&
              data.practices.find((x) => x.practice_id == _vm.currentPractice.id)
                .active)
              ? 'border-left: 5px solid #22b14c'
              : ''),on:{"click":function($event){return _vm.switchItem(data)}}},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"draggable-item-trigger-a draggable-item-trigger-container pl-3 handle",class:{
                'd-none': _vm.variant && _vm.variant == 'simple',
                'd-none': _vm.item && _vm.item.draggable === false,
              }},[_c('div',{staticClass:"draggable-item-trigger"})]),_c('div',{staticClass:"media-body overflow-hidden p-2"},[_c('p',{staticClass:"text-truncate font-size-14 mb-0 px-2"},[(
                    data.id == _vm.selectedItem.id
                      ? _vm.selectedItem.featured
                      : data.featured
                  )?_c('i',{staticClass:"ri-star-fill mr-2",staticStyle:{"color":"gold"}}):_vm._e(),_c('span',{staticClass:"align-top",style:(data &&
                    data.additionalProp1 &&
                    data.additionalProp1.global
                      ? data.practices &&
                        data.practices.find(
                          (x) => x.practice_id == _vm.currentPractice.id
                        ) &&
                        !data.practices.find(
                          (x) => x.practice_id == _vm.currentPractice.id
                        ).active
                        ? data.id !== _vm.selectedItem.id
                          ? 'color: gray'
                          : ''
                        : ''
                      : 'active' in data && !data.active
                      ? data.id !== _vm.selectedItem.id
                        ? 'color: gray'
                        : ''
                      : '')},[_vm._v(" "+_vm._s(_vm.moment(data.title, "YYYY-MM-DD", true).isValid() ? _vm.moment(new Date(data.title)).format("DD MMMM, YYYY") : data.title)+" ")])])])])])])})],2)],1):_c('div',[_c('p',[_vm._v("No items found!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }